import { jsx as e } from "react/jsx-runtime";
import { Switch as r } from "antd";
import { memo as c } from "react";
const l = c(function({
  value: o,
  onChange: t
}) {
  return /* @__PURE__ */ e(r, { checked: o ?? !1, onChange: t });
});
export {
  l as default
};
//# sourceMappingURL=ActionSelector.js.map
